import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-email-block",
  type: "FormEmailBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Email",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
  },
};
